/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

//LENDARIUS - VER FICHEIRO FILTERS-DIALOG.JS
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const allFilters = document.querySelectorAll('details[open]');
    
    allFilters.forEach((filter, index) => {
      if (index !== 0) {
        filter.removeAttribute('open');
      }
    });
  }, 300); // podes aumentar se o tema demorar mais a aplicar os "open"
});

// No seletor dos idiomas abrevia o texto
document.querySelectorAll('.list-menu__text, .secondary-nav__link').forEach(el => {
  let isSecondary = el.classList.contains('secondary-nav__link');

  if (isSecondary) {
    // Encontra apenas o nó de texto (antes do ícone)
    let textNode = Array.from(el.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
    if (textNode) {
      let txt = textNode.textContent.trim().toLowerCase();
      if (txt.includes('português')) textNode.textContent = 'PT ';
      if (txt.includes('español'))  textNode.textContent = 'ES ';
      if (txt.includes('english'))  textNode.textContent = 'EN ';
    }
  } else {
    // Para .list-menu__text é simples: substituir tudo
    let txt = el.textContent.trim().toLowerCase();
    if (txt.includes('português')) el.textContent = 'PT';
    if (txt.includes('español'))  el.textContent = 'ES';
    if (txt.includes('english'))  el.textContent = 'EN';
  }
});


//LENDARIUS - NOME DA VARIANTE A SEGUIR AO NOME DO PRODUTO
document.addEventListener('DOMContentLoaded', function() {
  const productTitle = document.querySelector('.product-single__title');
  const colorInputs = document.querySelectorAll('input[name="Cor"]');
  
  if (!productTitle || !colorInputs.length) return;

  const originalTitle = productTitle.textContent.trim();

  function updateProductTitle(selectedColor) {
    if (selectedColor) {
      productTitle.textContent = `${originalTitle} - ${selectedColor}`;
    } else {
      productTitle.textContent = originalTitle;
    }
  }

  // Atualiza ao clicar nas opções de cor
  colorInputs.forEach(input => {
    input.addEventListener('change', () => {
      updateProductTitle(input.value.trim());
    });
  });

  // Atualiza ao carregar a página, se já houver uma cor selecionada
  const checkedInput = Array.from(colorInputs).find(i => i.checked);
  if (checkedInput) {
    updateProductTitle(checkedInput.value.trim());
  }
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.list-menu__text').forEach(el => {
        const texto = el.textContent.trim().toLowerCase();

        if (texto === 'sam & julia') {
            el.innerHTML = `
                <span class="keep-upper">S</span>am & 
                <span class="keep-upper">J</span>ulia
            `;
        }
    });
});

document.querySelectorAll('.mega-links__link').forEach(el => {

    const texto = el.innerHTML;

    // Se contiver &nbsp; no HTML original
    if (texto.includes('menu-hidden')) {
        el.style.visibility = 'hidden';
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const links = document.querySelectorAll('.primary-nav__link');
    
    links.forEach(link => {
        if (link.textContent.trim() === "BLACK MOON DAYS") {
            link.style.backgroundColor = "#000";
            link.style.color = "#fff";
            link.style.padding ="10px"
        }
    });
});

/* -----------------------------------------------------------
   Correção para evitar a duplicação do nome da variação nos
   títulos dos produtos nas listagens de coleção. O script
   limpa automaticamente títulos do tipo:
   "Produto - Variante - Variante"
   mantendo apenas:
   "Produto - Variante"
   Devido à incompatibilidade da APP de Variantes
----------------------------------------------------------- */
(function() {
  function limparTitulo(card) {
    if (!card || !card.textContent) return;

    var titulo = card.textContent.trim();
    if (titulo.indexOf(" - ") === -1) return;

    var partes = titulo.split(" - ").map(function(p) { return p.trim(); });
    if (partes.length < 3) return;

    var ultima = partes[partes.length - 1];
    var penultima = partes[partes.length - 2];

    if (ultima === penultima) {
      partes.pop();
      card.textContent = partes.join(" - ");
    }
  }

  function processarTodos() {
    var cards = document.querySelectorAll("product-card-title");
    cards.forEach(limparTitulo);
  }

  // primeira passagem
  document.addEventListener("DOMContentLoaded", processarTodos);
  window.addEventListener("load", processarTodos);

  // para cards carregados por JS / app / infinite scroll
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches("product-card-title")) {
          limparTitulo(node);
        }

        var internos = node.querySelectorAll
          ? node.querySelectorAll("product-card-title")
          : [];
        internos.forEach(limparTitulo);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();



/* -----------------------------------------------------------
   Corrigir a ordem das imagens nos product cards,
   garantindo que:
   - a imagem principal é sempre a primeira (visível)
   - a imagem secundária é sempre a segunda (hover)
   Compatível com EX Show Variants e com o tema atual.
----------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", () => {

  function fixImageOrder() {
    document.querySelectorAll(".product-card__media").forEach(media => {

      const hoverWrapper = media.querySelector("product-card-secondary-image-placeholder");
      const mainImg = media.querySelector(".js-product-card-image");

      if (!hoverWrapper || !mainImg) return;

      // Se o hover estiver antes da principal → inverte
      const hoverIsFirst = hoverWrapper === media.firstElementChild;

      if (hoverIsFirst) {
        media.appendChild(hoverWrapper); // move hover para o fim
      }
    });
  }

  fixImageOrder();

  // observar alterações que vêm do EX Show Variants
  new MutationObserver(fixImageOrder).observe(document.body, {
    childList: true,
    subtree: true
  });

});
